/**
 * 
 * 
 * Route Layout
 * 
 */


 import React, { lazy, Suspense, memo } from 'react'
 import PropTypes from 'prop-types'
 import _ from 'lodash'
 
 
 function Grid(props) {
     const { grid } = props
     return (<React.Fragment>
         {(grid || []).map(({ id, component, ...rest }) => {
             const Grid = component && typeof component === 'string' ? lazy(() => import(`../${component}`)) : component
 
             return <Suspense key={id} fallback={<div>Loading...</div>}>
                 <Grid {...props} {...rest} />
             </Suspense>
         })}
     </React.Fragment>)
 }
 
 
 Grid.propTypes = {
     grid: PropTypes.any,
     children: PropTypes.any
 }
 
 
 
 export default memo(Grid, (prevProps, nextProps) => {
     return _.isEqual(prevProps && prevProps.metaData, nextProps && nextProps.metaData)
 })